import { createLoading } from '../../meta/loading.js'

$.nette.ext('loadingStates', {
    start: (xhr, settings) => {
        if (settings?.nette?.el) {
            settings.nette.el[0].classList.add('is-loading')
        }

        let loaderEl = null

        if (settings?.formElement) {
            loaderEl = settings.formElement.closest('[data-loading]')
        } else if (settings?.nette?.el && settings.nette.el[0].dataset.loader !== undefined) {
            loaderEl = settings.nette.el[0].closest('[data-loading]')
        }

        if (loaderEl && loaderEl.dataset.loading !== 'prevent') {
            const options = {}

            if (loaderEl.dataset.loadingDelay) {
                options.delay = parseInt(loaderEl.dataset.loadingDelay || 0)
            }

            const loading = createLoading(loaderEl, options)
            loading.show()

            settings._loading = loading
        }
    },
    complete: (xhr, status, settings) => {
        if (settings?.nette?.el) {
            settings.nette.el[0].classList.remove('is-loading')
        }

        const loading = settings?._loading
        if (loading) {
            loading.destroy()
        }
    }
})
